import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Loading } from '../';

const RichTextEditor = ({
  initialValue = '',
  onContentChange,
  onMediaUpload,
}) => {
  const [, setContent] = useState('content');
  const [isLoading, setIsLoading] = useState(true);

  const handleEditorChange = (e) => {
    setContent(e.target.getContent());
    onContentChange(e.target.getContent());
  };

  return (
    <div>
      <div className="w-100 text-center position-relative">
        <div className="w-95 radius-md mx-auto my-4">
          <Editor
            apiKey={process.env.REACT_APP_TINY_MCE_EDITOR_API_KEY}
            initialValue={initialValue}
            onInit={() => setIsLoading(false)}
            init={{
              directionality: 'rtl',
              language: 'fa',
              height: 600,
              menubar: true,
              file_picker_callback: 'image',
              automatic_uploads: true,
              images_upload_handler: onMediaUpload,
              plugins: [
                'advlist autolink table lists link image charmap print preview anchor',
                'searchreplace visualblocks fullscreen',
                'insertdatetime paste ',
              ],
              toolbar:
                'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ',
            }}
            onChange={handleEditorChange}
          />
        </div>
      </div>
      {isLoading ? (
        <div className="w-100 mt-5 mh-16 flex-center-center ">
          <Loading loading={isLoading} />
        </div>
      ) : null}
    </div>
  );
};

export default RichTextEditor;
